import React from 'react';
import ContentLoader from 'react-content-loader';
import styles from './Skeleton.module.sass';

export const SkeletonNewsCard = ({ animate, ...props }) => (
  <div className={styles.card}>
    <ContentLoader
      speed={1}
      width={400}
      animate={animate}
      viewBox="0 0 356 403"
      backgroundColor="#F3F6F9"
      foregroundColor="#F9F9F9"
      style={{ maxWidth: '100%', minWidth: '100%' }}
      {...props}
    >
      <rect x="0" y="0" rx="0" ry="0" width="356" height="172" />
      <rect x="16" y="188" rx="0" ry="0" width="328" height="60" />
      <rect x="16" y="256" rx="0" ry="0" width="285" height="20" />
      <rect x="16" y="284" rx="0" ry="0" width="245" height="20" />
      <rect x="16" y="312" rx="0" ry="0" width="205" height="20" />
      <rect x="16" y="460" rx="0" ry="0" width="342" height="1" />
      <rect x="16" y="493" rx="0" ry="0" width="125" height="24" />
      <rect x="174" y="476" rx="4" ry="4" width="170" height="56" />
    </ContentLoader>
  </div>
);
